import React from 'react'

import { const_var } from '../../../redux/reducers/reducer';
import CenterBuildingMeasurement from './CenterBuildingMeasurement';

const Measurements = () => {
    const color = '#2F7CBF'
    
    return const_var.callMesure && (
        <CenterBuildingMeasurement color={color} />
    )
}

export default Measurements